import LoaderSuspense from './_loader-suspense.js'
import FlexPane from './_flex-pane.js'
import EventList from './_event-list.js'
import EmptyContent from './_empty-content.js'
import EventListSkeleton from './_event-list-skeleton.js'

export default {
  name: 'EventsCoupon',
  values: {
    groupsExpandable: true,
    initialExpandedGroups: -1,
    maxEventsToRender: -1,
    maxGroupsToRender: -1,
    enableContentLazyLoading: false,
    reportLoadingStatus: false,
    enableSorting: true,
    skeletonLoader: {
      configSet: LoaderSuspense,
      configValues: {
        showLoaderDelay: -1,
        style: {
          container: {
            maxWidth: '100%',
          },
          hidden: {
            display: 'block',
            width: '100%',
            position: 'absolute',
            visibility: 'hidden',
            opacity: 0,
            zIndex: -1,
          },
        },
      },
    },
    container: {
      configSet: FlexPane,
      configValues: {
        createStackingContext: true,
      },
    },
    eventList: {
      configSet: EventList,
      configValues: {},
    },
    emptyContent: {
      configSet: EmptyContent,
      configValues: {},
    },
    eventListSkeleton: {
      configSet: EventListSkeleton,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
